export default {
    type: 'table',
    name: 'Table',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleTable',
            loader: () => import('./ModuleTable')
        }
    }
};
